import { MenuHelper, IMenuDefinition, menuType } from "@/helpers/MenuHelper";
import { layoutHelper } from '@/helpers/LayoutHelper';

export function init() {
  if (layoutHelper.isWeb){
    MenuHelper.addMenuDefinition(
      { name: "mapVisualization", description: "Visualizzazione in Mappa", icon: "fas fa-map", routeName: "mapVisualization", orderIndex: 1, group: "Visualizzazione in Mappa" } as IMenuDefinition,
      { section: menuType.drawer },
    );
  }
}

export const symbol = {
  type: "simple-fill",
  color: [60, 179, 113, 0.8],
  outline: {
    color: [255, 255, 255],
    width: 2
  }
};

export const invalidSymbol = {
  type: "simple-fill",
  style: "diagonal-cross",
  color: [255, 0, 0],
  outline: {
    color: [255, 255, 255],
    width: 2
  }
}
